import React from 'react';
import { Question, Video, FileZip, CalendarBlank } from '@phosphor-icons/react';
import classNames from 'classnames';

import {
  trackUGModalOpen,
  trackOnboardingModalOpen,
  trackQuickstartPackDownload,
} from '../../../../analytics';

import aflThumbnail from '../../../../assets/afl-event-thumbnail.jpeg';

import { ZIP_URL } from '../../../../constants';

interface Props {
  setShowUGModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowOnboardingVideo: React.Dispatch<React.SetStateAction<boolean>>;
  handleOpenSampleProject: () => void;
}

const LearningMaterials: React.FC<Props> = (props) => {
  const { setShowUGModal, setShowOnboardingVideo, handleOpenSampleProject } =
    props;

  const learningBlocks = [
    {
      image:
        'https://t3.ftcdn.net/jpg/05/24/43/88/360_F_524438877_PZFzwc5OWJ3MTWQVFfHKwu1DRVMaSgPx.jpg',
      Icon: Question,
      label: 'How does it work?',
      onClick: () => {
        setShowUGModal(true);
        trackUGModalOpen();
      },
    },
    {
      image:
        'https://cdn.pixabay.com/photo/2022/09/21/17/02/blue-background-7470781_640.jpg',
      Icon: Video,
      label: 'Watch onboarding video',
      onClick: () => {
        setShowOnboardingVideo(true);
        trackOnboardingModalOpen();
      },
    },
    {
      image:
        'https://st4.depositphotos.com/1741969/29457/i/450/depositphotos_294571810-stock-photo-blackground-of-abstract-glitter-lights.jpg',
      Icon: FileZip,
      label: 'Download the quickstart pack',
      onClick: () => {
        window.location.href = ZIP_URL.QUICKSTART;
        trackQuickstartPackDownload('Learning materials');
      },
    },
    {
      image: aflThumbnail,
      Icon: CalendarBlank,
      label: 'Play with Sample Project',
      onClick: () => handleOpenSampleProject(),
    },
  ];

  return (
    <div className="w-full flex flex-col gap-4">
      <h5>Don't know where to start?</h5>

      <div className="flex flex-wrap gap-4 lg:gap-7">
        {learningBlocks.map((block) => {
          const thumbnailClass =
            'w-[var(--project-block-width)] xl:w-[calc((var(--page-width)_-_(1.5rem_*_5))_/_6)] aspect-[1/0.9] rounded-md';

          return (
            <button
              className="group relative"
              onClick={block.onClick}
              key={block.label}
            >
              <img
                className={classNames(thumbnailClass, 'relative object-cover')}
                src={block.image}
                alt="Learning block"
              />

              <div
                className={classNames(
                  thumbnailClass,
                  'absolute top-0 left-0 bg-black-overlay-500 transition-all group-hover:bg-black',
                )}
              />

              <div
                className={classNames(
                  thumbnailClass,
                  'absolute top-0 left-0 flex flex-col items-center justify-center text-center p-2 md:p-4 gap-2 text-white transition-all group-hover:scale-110',
                )}
              >
                <block.Icon className="w-8 h-8 sm:w-10 sm:h-10" />

                <div className="text-md sm:text-sm xl:text-md">
                  {block.label}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LearningMaterials;
